export const aboutInfo = {
  brandName: '屁屁影院',
  brandIntro: '屁屁影院成立于2021年，是国内领先的免费在线影视资源导航平台。我们致力于为广大影迷提供海量高清电影、电视剧、动漫等资源的在线观看服务。平台秉承"免费、高清、流畅"的核心理念，无需注册即可畅享极致观影体验。',
  mission: '让每一个喜欢影视的人都能随时随地免费看到想看的影片。',
  features: [
    {
      icon: 'ri-movie-2-line',
      title: '海量资源',
      description: '收录超过10万部电影、电视剧、动漫资源，涵盖国内外各类题材，满足不同用户的观影需求。',
    },
    {
      icon: 'ri-4k-line',
      title: '高清画质',
      description: '支持HD高清、4K超清等多种画质选择，配合多线路切换功能，确保最佳观影效果。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速播放',
      description: '采用先进的CDN加速技术，全国多节点部署，确保播放流畅不卡顿。',
    },
    {
      icon: 'ri-refresh-line',
      title: '更新及时',
      description: '专业编辑团队24小时跟踪最新影视动态，确保资源第一时间更新上线。',
    },
    {
      icon: 'ri-device-line',
      title: '多端适配',
      description: '完美适配PC、平板、手机等多种设备，随时随地畅享观影乐趣。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全无广告',
      description: '绿色安全无弹窗广告，纯净观影环境，保护用户隐私安全。',
    },
  ],
  stats: [
    { number: '100,000+', label: '影视资源' },
    { number: '5,000,000+', label: '日活用户' },
    { number: '99.9%', label: '播放成功率' },
    { number: '24H', label: '更新响应' },
  ],
  reviews: [
    {
      name: '电影爱好者小王',
      avatar: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20young%20Chinese%20man%2C%20friendly%20smile%2C%20casual%20style%2C%20clean%20background&width=100&height=100&seq=pipi-avatar-01&orientation=squarish',
      rating: 5,
      content: '用了屁屁影院两年多了，资源真的太全了！不管是国产新片还是国外大片，基本上都能找到。画质也很给力，强烈推荐！',
      date: '2026-07-15',
    },
    {
      name: '追剧达人小李',
      avatar: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20young%20Chinese%20woman%2C%20warm%20smile%2C%20modern%20style%2C%20clean%20background&width=100&height=100&seq=pipi-avatar-02&orientation=squarish',
      rating: 5,
      content: '追剧必备神器！更新速度非常快，基本上电视台播完这边就有了。切换线路功能也很实用，再也不怕卡顿了。',
      date: '2026-07-10',
    },
    {
      name: '动漫迷老张',
      avatar: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20Chinese%20man%20in%20his%2030s%2C%20confident%20look%2C%20casual%20style%2C%20clean%20background&width=100&height=100&seq=pipi-avatar-03&orientation=squarish',
      rating: 5,
      content: '作为一个资深动漫迷，屁屁影院的动漫资源真的没话说。日漫国漫都有，而且更新速度巨快，每周新番同步更新！',
      date: '2026-07-05',
    },
    {
      name: '家庭观影刘姐',
      avatar: 'https://readdy.ai/api/search-image?query=portrait%20photo%20of%20Chinese%20middle-aged%20woman%2C%20kind%20smile%2C%20warm%20style%2C%20clean%20background&width=100&height=100&seq=pipi-avatar-04&orientation=squarish',
      rating: 4,
      content: '每天晚上和孩子一起在屁屁影院看动画片，资源丰富，操作简单，老人小孩都能轻松使用。真的是很好的平台！',
      date: '2026-06-28',
    },
  ],
  faqs: [
    {
      question: '屁屁影院需要注册才能观看吗？',
      answer: '不需要！屁屁影院完全免费，无需注册即可观看所有影视资源。我们相信好的服务不需要门槛。',
    },
    {
      question: '为什么有时播放会卡顿？如何解决？',
      answer: '播放卡顿可能与您的网络环境有关。建议您尝试切换播放线路（点击播放器下方的线路按钮），或者降低画质以获得更流畅的体验。',
    },
    {
      question: '支持哪些设备观看？',
      answer: '屁屁影院完美适配PC电脑、平板、手机等设备。您可以在任何支持浏览器的设备上访问我们的网站，随时随地畅享观影。',
    },
    {
      question: '资源多久更新一次？',
      answer: '我们的编辑团队全天候24小时跟踪最新影视动态。热门剧集通常在播出后2小时内更新，电影一般在网络版上线当天即可观看。',
    },
    {
      question: '可以下载影片离线观看吗？',
      answer: '目前我们主要提供在线播放服务。为了更好的观影体验，建议在网络良好的环境下在线观看。',
    },
    {
      question: '如何联系我们反馈问题？',
      answer: '您可以通过页面底部的联系方式或发送邮件至我们的客服邮箱与我们取得联系。我们会在24小时内回复您的反馈。',
    },
  ],
  contact: {
    email: 'support@ppcinema.com',
    wechat: 'ppcinema_official',
    weibo: '@屁屁影院官方',
    qq: '1234567890',
    workingHours: '周一至周日 9:00 - 21:00',
  },
};